<template>
  <div>
    <navigation></navigation>

    <div class="container px-4 mx-auto">
      <h1 class="mb-5">Create a New Notebook</h1>

      <div class="row">
        <div class="col-md-12">
          <form data-cy="create-notebook-form" v-on:submit.prevent="createBook">
            <div class="row">
              <div class="col-md-6">
                <div class="form-book">
                  <label class="for-reader">Notebook Title:</label>
                  <input
                    class="mb-3 input-text-1"
                    data-cy="title-input"
                    placeholder="Notebook Title"
                    type="text"
                    v-model="book.title"
                  />
                  <v-select
                    :onChange="selected"
                    :options="categories"
                    :value="category"
                    class="mb-3"
                    placeholder="Notebook type"
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="form-book">
              <button class="button-1" data-cy="create-notebook-button">
                Create Notebook
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { API_URL } from "../../env";
import Navigation from "../Navigation.vue";
import vSelect from "vue-select";
import axios from 'axios';
import qs from "query-string";

export default {
  data() {
    return {
      book: {},
      categories: [
        {
          label: "Simple",
          value: "simple"
        },
        {
          label: "Date",
          value: "date"
        }
      ],
      category: {
        label: "Simple",
        value: "simple"
      }
    };
  },
  components: {
    Navigation,
    "v-select": vSelect
  },
  methods: {
    async createBook() {
      this.$loading(true);
      if (!this.book.title || !this.category) {
        alert("Some information is missing. Please review.");
        return;
      }
      let data = {
        book: this.book,
        type: this.category,
      };
      if (this.$route.query.parent_id) {
        data.parent_id = this.$route.query.parent_id;
      }
      const authHeaders = this.$store.getters.authHeaders;
      const uri = `${API_URL}/admin/books/create`;
      axios.post(uri, data, authHeaders).then(response => {
        const config = {
          status: "success",
          message: "Your notebook was successfully created.",
          time: 3000
        };
        this.flashMessage.show(config);
        this.$loading(false);
        this.$router.push({ path: `/admin/notes?book=${response.data.book.id}` });
      });
    },
    selected(option) {
      this.category = option;
    }
  },
  mounted: function() {
    // tinymce.init({ selector:'#edit-doc', plugins: 'link, lists' });
  },
  created: function() {
    console.log('query', this.$route);
    // this.tinyMCE.activeEditor.setContent('hello');
  }
};
</script>
